// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import * as Browser$BenfaerberBlog from "../wrappers/Browser.bs.js";
import * as Project$BenfaerberBlog from "../lib/Project.bs.js";
import * as ProjectItem$BenfaerberBlog from "../components/ProjectItem.bs.js";
import * as LanguageSelector$BenfaerberBlog from "../components/LanguageSelector.bs.js";
import * as ProjectItemLoading$BenfaerberBlog from "../components/ProjectItemLoading.bs.js";

function s(prim) {
  return prim;
}

function ProjectsPage(props) {
  var match = React.useState(function () {
        return false;
      });
  var setIsLoading = match[1];
  var match$1 = React.useState(function () {
        return [];
      });
  var setProjects = match$1[1];
  var projects = match$1[0];
  var match$2 = React.useState(function () {
        return [];
      });
  var setVisibleProjects = match$2[1];
  var match$3 = React.useState(function () {
        return "Other";
      });
  var language = match$3[0];
  var match$4 = ReactRouterDom.useParams();
  var slug = match$4.slug;
  var hasSecret = slug !== undefined ? slug === "secret" : false;
  React.useEffect((function () {
          var projectGetter = hasSecret ? Project$BenfaerberBlog.Api.getAllProjects : Project$BenfaerberBlog.Api.getProjects;
          projectGetter().then(function (projects) {
                  var sortedProjects;
                  if (slug !== undefined && !hasSecret) {
                    var foundProduct = Belt_Array.getBy(projects, (function (p) {
                            return p.slug === slug;
                          }));
                    var withoutFirst = Belt_Array.keep(projects, (function (p) {
                            return p.slug !== slug;
                          }));
                    sortedProjects = Belt_Array.concat([foundProduct], withoutFirst);
                  } else {
                    sortedProjects = projects;
                  }
                  setIsLoading(function (param) {
                        return false;
                      });
                  setProjects(function (param) {
                        return sortedProjects;
                      });
                  return Promise.resolve(setVisibleProjects(function (param) {
                                  return sortedProjects;
                                }));
                }).then(function () {
                return Promise.resolve(slug !== undefined && !hasSecret ? Browser$BenfaerberBlog.$$Window.scrollToElement("#project-" + slug) : undefined);
              });
        }), [slug]);
  React.useEffect((function () {
          if (language === "Other") {
            setVisibleProjects(function (param) {
                  return projects;
                });
          } else {
            setVisibleProjects(function (param) {
                  return Belt_Array.keep(projects, (function (p) {
                                return p.language === language;
                              }));
                });
          }
        }), [language]);
  return JsxRuntime.jsxs("div", {
              children: [
                hasSecret ? JsxRuntime.jsx("h3", {
                        children: "I had to hide these projects because some people have a stick up their ass...."
                      }) : "",
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(LanguageSelector$BenfaerberBlog.make, {
                            language: language,
                            projects: projects,
                            setLanguage: match$3[1]
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: match[0] ? Belt_Array.map(Belt_Array.range(0, 10), (function (i) {
                                return JsxRuntime.jsx(ProjectItemLoading$BenfaerberBlog.make, {}, String(i));
                              })) : Belt_Array.map(match$2[0], (function (project) {
                                return JsxRuntime.jsx(ProjectItem$BenfaerberBlog.make, {
                                            project: project,
                                            size: "Large"
                                          }, "project-" + project.slug);
                              })),
                      className: "is-flex is-flex-wrap-wrap"
                    })
              ]
            });
}

var make = ProjectsPage;

export {
  s ,
  make ,
}
/* react Not a pure module */
